import React, { useRef, useState } from "react";
import FullScreenSignatureCanvas from "./components/full-screen-signature-canvas";
import generatePdf from "./components/generate-pdf";
import AllegationContent from "./components/allegation-content";
import "./app.css";
import { alegaciones, introducciones, solicitudes } from "./alegaciones";

const MAX_ALEGACIONS = 20;
const NOMBRE_POLIGONO = "POLÍGONO EÓLICO ANDURIÑA";

const randomNumber = (number) => Math.ceil(Math.random() * number);

const getRandom = (list, number) =>
  list.sort(() => 0.5 - Math.random()).slice(0, number);

const initialData = {
  name: "",
  address: "",
  document: "",
  town: "",
  province: "",
  postalCode: "",
};

const App = () => {
  const [data, setData] = useState(initialData);
  const [showAllegations, setShowAllegations] = useState(false);
  const [introduction, setIntroduction] = useState(
    getRandom(introducciones, 1)
  );
  const [allegations, setAllegations] = useState(
    getRandom(alegaciones, randomNumber(MAX_ALEGACIONS))
  );
  const [request, setRequest] = useState(getRandom(solicitudes, 1));
  const signatureRef = useRef({});
  const { name, address, document, town, province, postalCode } = data;

  const setUserData = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const downloadPdf = () => {
    generatePdf({
      name,
      address,
      document,
      town,
      province,
      postalCode,
      allegations,
      signature: signatureRef.current,
      introduction,
      request,
    });
  };

  return (
    <div className="container">
      <h1 className="title">Alegacións ao {NOMBRE_POLIGONO}</h1>
      <p className="subtitle">
        Dende esta web podes encher, firmar e descargar a alegación ao P.E
        Anduriña.
        <br />
        Depois terás que presentala por rexistro: podes seguir{" "}
        <a href="https://mapaseolicos.files.wordpress.com/2022/04/manual_alegaciones_registro_online_2.pdf">
          este manual
        </a>
        <br />
        Podes correxir calquera dato e volver a xerar o PDF se te trabucaches.
      </p>
      <div className="form">
        <form>
          <label htmlFor="name">Nome completo</label>
          <input
            type="text"
            id="name"
            value={name}
            name="name"
            onChange={setUserData}
          />

          <label htmlFor="address">Dirección</label>
          <input
            id="address"
            value={address}
            name="address"
            onChange={setUserData}
          />

          <label htmlFor="documentNumber">DNI/NIE</label>
          <input
            type="text"
            id="documentNumber"
            value={document}
            name="document"
            onChange={setUserData}
          />

          <label htmlFor="town">Concello</label>
          <input
            type="text"
            id="town"
            value={town}
            name="town"
            onChange={setUserData}
          />

          <label htmlFor="province">Provincia</label>
          <input
            type="text"
            id="province"
            value={province}
            name="province"
            onChange={setUserData}
          />

          <label htmlFor="postalCode">Código Postal</label>
          <input
            type="text"
            id="postalCode"
            value={postalCode}
            name="postalCode"
            onChange={setUserData}
          />
          <div className="allegations">
            <a
              href="#"
              className="linkButton"
              onClick={() => setShowAllegations((prevShow) => !prevShow)}
            >
              {!showAllegations
                ? "⬇️ Deplegar para ver as alegacións ⬇️"
                : "⬆️ Deixar de amosar alegacións ⬆️"}
            </a>
            {showAllegations && (
              <div className="allegationContent">
                <AllegationContent
                  introduction={introduction}
                  allegations={allegations}
                  request={request}
                />
              </div>
            )}
          </div>
          <h2>Firma no recadro</h2>
          <div class="signExplanation">
            <p className="hint">
              Escribe co dedo, ou co rato (pulsa e arrastra) a túa firma.
              <br />
              Ocupa todo o ancho aser posible.
              <br />
              Se queres volver a facela, preme "Repetir". Tes un exemplo á
              dereita.
            </p>
            <img src="https://media.wired.com/photos/5cf07ad08f6eb299a2598e39/2:1/w_899,h_449,c_limit/Culture%20-%20Top%20Art%20-%20Signatures.gif" />
          </div>
          <FullScreenSignatureCanvas signatureRef={signatureRef} />
        </form>
      </div>
      <div className="footer">
        <p className="hint">
          Xa podes descargar a túa alegación firmada e lista para imprimir,
          preme Xerar PDF
        </p>
        <p className="hint">
          Poderala presentar en calquera rexistro. Podes correxir calquera dato
          e volver a xeralo se te trabucaches.
        </p>
        <div className="actionButtons">
          <button className="generate" onClick={downloadPdf}>
            📃 Xerar PDF
          </button>
          <button onClick={() => location.reload()}> ✍🏻 Comezar de novo</button>
        </div>
      </div>
    </div>
  );
};

export default App;
